export default __webpack_public_path__ + "static/media/My_Highlights_page_empty_1_720x512.c7862a22.png";